import dayjs from 'dayjs';

import { usePaginatedWorkloadsEfficiencyQuery } from 'hooks/queries/cost/usePaginatedWorkloadsEfficiencyQuery';

import { useCluster } from '@cast/shared-cluster-context-data-access';

/**
 * Whether the cluster has Metrics Server installed.
 * Uses Cost Report efficiency API (`metricsServerAvailable`) as the signal —
 * WOOP agent status does not expose this field yet.
 *
 * TODO(WOOP-2150): Prefer a dedicated field on WOOP agent status once available,
 * so this page does not need a separate efficiency query.
 */
export const useIsMetricsServerAvailable = () => {
  const { cluster } = useCluster();

  // Minimal non-zero window — efficiency API may require startTime < endTime;
  // metricsServerAvailable is treated as cluster-level, not range-derived.
  const endTime = dayjs().startOf('h').toISOString();
  const startTime = dayjs().startOf('h').subtract(1, 'hour').toISOString();

  const { metricsServerAvailable, isLoading, error } =
    usePaginatedWorkloadsEfficiencyQuery({
      clusterId: cluster.id,
      startTime,
      endTime,
      pageLimit: 1,
      useListingPrices: false,
    });

  return {
    isMetricsServerAvailable: metricsServerAvailable,
    isLoading,
    isError: !!error,
  };
};
